import type { ProfileEditPatch } from "../../../lib/profile/use-profile-edit";

/**
 * Maps a row + raw select value to the PATCH /api/profile patch body. Returns
 * null when the value can't produce a valid patch (empty band, non-numeric
 * months) so the caller skips the mutation. Pure + exported for unit tests.
 */
export function buildProfilePatch(
  rowId: string,
  value: string,
): ProfileEditPatch | null {
  if (rowId === "credit") {
    return value ? { credit_score_range: value } : null;
  }
  if (rowId === "employment") {
    const months = Number(value);
    return Number.isFinite(months) && value !== ""
      ? { employment_months: months }
      : null;
  }
  return null;
}
